import { IFilterField } from '@routes/addressbook/models/addressbook-model';

export interface IList {
    id: string;
    name: string;
    filter: IListFilter;
    isActive: boolean;
    contactCount: number;
    mostRecentlySyncedAt: Date;
    ownerId: string;
    ownerName: string;
    isPublic: boolean;
    disabled?: boolean;
}

export class AddList implements IList {
    constructor(
        public id: string,
        public name: string,
        public filter: IListFilter,
        public isActive: boolean,
        public contactCount: number,
        public mostRecentlySyncedAt: Date,
        public ownerId: string,
        public ownerName: string,
        public isPublic: boolean
    ) { }
}

export interface IListForDropdown {
    id: string;
    text: string;
}

export class ListForDropdown implements IListForDropdown {
    constructor(
        public id: string,
        public text: string
    ) { }
}

export interface IListsForDropdown {
    queries: IListForDropdown[];
}

export interface ILists {
    queries: IList[];
}

export interface IListFilter {
    filters: IFilterField[];
}
